import CssClassMixin from '../../mixins/css_class_mixin.jsx';

var createClass = require('create-react-class');

window.ModalContent  = createClass({
  mixins: [CssClassMixin],

  getDefaultProps: function() {
    return {
      themeClassKey: 'modal.content'
    };
  },

  render: function() {
    return <div className={this.className()}>{this.props.children}</div>;
  }
});
